<template>
    <b-toast
            :toast-class="[icon ? 'toast-with-icon' : '']"
            :visible="internalState"
            :no-auto-hide="true"
            variant="indigo"
            no-close-button
            solid
    >
<template v-slot:toast-title>
            <i
                    v-if="icon"
                    class="fal mr-2 fa-1x"
                    :class="[icon ? 'fa-' + icon : '' ]"
            />
            <h4 class="text-white mb-0">
NOTIFICATION TITLE
</h4>
            <button
                    type="button"
                    aria-label="Close"
                    class="close"
                    @click="closeToast"
            >
                <i class="fal fa-times" />
            </button>
        </template>
        <template
                v-slot:default
                :style="bodyStyle"
        >
            <p>
                This is the content of the toast.
                It is short and to the point.
            </p>
            <a
                    class="text-white"
                    href="#"
            >Call to Action
            </a>
        </template>
</b-toast>
</template>

<script>
    import {BToast} from 'bootstrap-vue';

    export default {
        extends: BToast,
        name: 'CustomToast',
        props: {
            visible: {
                type: Boolean,
                default: false,
            },
            icon: {
                type: String,
            },

        },
        data() {
            return {
                internalState: this.visible,
            };
        },
        watch: {
            visible: function (newVal, oldVal) {
                this.internalState = newVal;
            }

        },
        computed: {},
        methods: {
            closeToast(value) {
                this.internalState = !this.internalState;
            },
        },
    };
</script>

<style scoped>

</style>
